import { useMemo } from 'react';
import { useDataFeedWizardStore } from '../../../store/dataFeedWizard';

export const useLinkedAccount = () => {
  const { linkAccountsData, configureMappingData } =
    useDataFeedWizardStore();

  const linkedAccountMap = useMemo(() => {
    const map = new Map<string, string>();

    for (const mapping of linkAccountsData.mappings) {
      if (!mapping.custodianId) continue;

      const label = [mapping.clientName, mapping.portfolioName, mapping.custodianName]
        .filter(Boolean)
        .join(' | ');

      map.set(mapping.accountNumber, label || mapping.custodianId);
    }

    return map;
  }, [linkAccountsData.mappings]);

  const hasLinkedAccounts = linkedAccountMap.size > 0;

  return {
    linkedAccountMap,
    hasLinkedAccounts,
    accountNumberColumn: configureMappingData.accountNumberColumn,
  };
};
